import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const FirstTimothy: Scripture = {
  version: VERSIONS.KJV,
  book: BOOKS.FIRST_TIMOTHY,
  chapters: [
    {
      chapter: "1",
      verses: [
        {
          verse: "1",
          text: "Paul, an apostle of Jesus Christ by the commandment of God our Saviour, and Lord Jesus Christ, which is our hope;",
        },
        {
          verse: "2",
          text: "Unto Timothy, my own son in the faith: Grace, mercy, and peace, from God our Father and Jesus Christ our Lord.",
        },
        {
          verse: "3",
          text: "As I besought thee to abide still at Ephesus, when I went into Macedonia, that thou mightest charge some that they teach no other doctrine,",
        },
        {
          verse: "4",
          text: "Neither give heed to fables and endless genealogies, which minister questions, rather than godly edifying which is in faith: so do.",
        },
        {
          verse: "5",
          text: "Now the end of the commandment is charity out of a pure heart, and of a good conscience, and of faith unfeigned:",
        },
        {
          verse: "6",
          text: "From which some having swerved have turned aside unto vain jangling;",
        },
        {
          verse: "7",
          text: "Desiring to be teachers of the law; understanding neither what they say, nor whereof they affirm.",
        },
        {
          verse: "8",
          text: "But we know that the law is good, if a man use it lawfully;",
        },
        {
          verse: "9",
          text: "Knowing this, that the law is not made for a righteous man, but for the lawless and disobedient, for the ungodly and for sinners, for unholy and profane, for murderers of fathers and murderers of mothers, for manslayers,",
        },
        {
          verse: "10",
          text: "For whoremongers, for them that defile themselves with mankind, for menstealers, for liars, for perjured persons, and if there be any other thing that is contrary to sound doctrine;",
        },
        {
          verse: "11",
          text: "According to the glorious gospel of the blessed God, which was committed to my trust.",
        },
        {
          verse: "12",
          text: "And I thank Christ Jesus our Lord, who hath enabled me, for that he counted me faithful, putting me into the ministry;",
        },
        {
          verse: "13",
          text: "Who was before a blasphemer, and a persecutor, and injurious: but I obtained mercy, because I did it ignorantly in unbelief.",
        },
        {
          verse: "14",
          text: "And the grace of our Lord was exceeding abundant with faith and love which is in Christ Jesus.",
        },
        {
          verse: "15",
          text: "This is a faithful saying, and worthy of all acceptation, that Christ Jesus came into the world to save sinners; of whom I am chief.",
        },
        {
          verse: "16",
          text: "Howbeit for this cause I obtained mercy, that in me first Jesus Christ might shew forth all longsuffering, for a pattern to them which should hereafter believe on him to life everlasting.",
        },
        {
          verse: "17",
          text: "Now unto the King eternal, immortal, invisible, the only wise God, be honour and glory for ever and ever. Amen.",
        },
        {
          verse: "18",
          text: "This charge I commit unto thee, son Timothy, according to the prophecies which went before on thee, that thou by them mightest war a good warfare;",
        },
        {
          verse: "19",
          text: "Holding faith, and a good conscience; which some having put away concerning faith have made shipwreck:",
        },
        {
          verse: "20",
          text: "Of whom is Hymenaeus and Alexander; whom I have delivered unto Satan, that they may learn not to blaspheme.",
        },
      ],
    },
    {
      chapter: "2",
      verses: [
        {
          verse: "1",
          text: "I exhort therefore, that, first of all, supplications, prayers, intercessions, and giving of thanks, be made for all men;",
        },
        {
          verse: "2",
          text: "For kings, and for all that are in authority; that we may lead a quiet and peaceable life in all godliness and honesty.",
        },
        {
          verse: "3",
          text: "For this is good and acceptable in the sight of God our Saviour;",
        },
        {
          verse: "4",
          text: "Who will have all men to be saved, and to come unto the knowledge of the truth.",
        },
        {
          verse: "5",
          text: "For there is one God, and one mediator between God and men, the man Christ Jesus;",
        },
        {
          verse: "6",
          text: "Who gave himself a ransom for all, to be testified in due time.",
        },
        {
          verse: "7",
          text: "Whereunto I am ordained a preacher, and an apostle, (I speak the truth in Christ, and lie not;) a teacher of the Gentiles in faith and verity.",
        },
        {
          verse: "8",
          text: "I will therefore that men pray every where, lifting up holy hands, without wrath and doubting.",
        },
        {
          verse: "9",
          text: "In like manner also, that women adorn themselves in modest apparel, with shamefacedness and sobriety; not with broided hair, or gold, or pearls, or costly array;",
        },
        {
          verse: "10",
          text: "But (which becometh women professing godliness) with good works.",
        },
        {
          verse: "11",
          text: "Let the woman learn in silence with all subjection.",
        },
        {
          verse: "12",
          text: "But I suffer not a woman to teach, nor to usurp authority over the man, but to be in silence.",
        },
        { verse: "13", text: "For Adam was first formed, then Eve." },
        {
          verse: "14",
          text: "And Adam was not deceived, but the woman being deceived was in the transgression.",
        },
        {
          verse: "15",
          text: "Notwithstanding she shall be saved in childbearing, if they continue in faith and charity and holiness with sobriety.",
        },
      ],
    },
    {
      chapter: "3",
      verses: [
        {
          verse: "1",
          text: "This is a true saying, If a man desire the office of a bishop, he desireth a good work.",
        },
        {
          verse: "2",
          text: "A bishop then must be blameless, the husband of one wife, vigilant, sober, of good behaviour, given to hospitality, apt to teach;",
        },
        {
          verse: "3",
          text: "Not given to wine, no striker, not greedy of filthy lucre; but patient, not a brawler, not covetous;",
        },
        {
          verse: "4",
          text: "One that ruleth well his own house, having his children in subjection with all gravity;",
        },
        {
          verse: "5",
          text: "(For if a man know not how to rule his own house, how shall he take care of the church of God?)",
        },
        {
          verse: "6",
          text: "Not a novice, lest being lifted up with pride he fall into the condemnation of the devil.",
        },
        {
          verse: "7",
          text: "Moreover he must have a good report of them which are without; lest he fall into reproach and the snare of the devil.",
        },
        {
          verse: "8",
          text: "Likewise must the deacons be grave, not doubletongued, not given to much wine, not greedy of filthy lucre;",
        },
        {
          verse: "9",
          text: "Holding the mystery of the faith in a pure conscience.",
        },
        {
          verse: "10",
          text: "And let these also first be proved; then let them use the office of a deacon, being found blameless.",
        },
        {
          verse: "11",
          text: "Even so must their wives be grave, not slanderers, sober, faithful in all things.",
        },
        {
          verse: "12",
          text: "Let the deacons be the husbands of one wife, ruling their children and their own houses well.",
        },
        {
          verse: "13",
          text: "For they that have used the office of a deacon well purchase to themselves a good degree, and great boldness in the faith which is in Christ Jesus.",
        },
        {
          verse: "14",
          text: "These things write I unto thee, hoping to come unto thee shortly:",
        },
        {
          verse: "15",
          text: "But if I tarry long, that thou mayest know how thou oughtest to behave thyself in the house of God, which is the church of the living God, the pillar and ground of the truth.",
        },
        {
          verse: "16",
          text: "And without controversy great is the mystery of godliness: God was manifest in the flesh, justified in the Spirit, seen of angels, preached unto the Gentiles, believed on in the world, received up into glory.",
        },
      ],
    },
    {
      chapter: "4",
      verses: [
        {
          verse: "1",
          text: "Now the Spirit speaketh expressly, that in the latter times some shall depart from the faith, giving heed to seducing spirits, and doctrines of devils;",
        },
        {
          verse: "2",
          text: "Speaking lies in hypocrisy; having their conscience seared with a hot iron;",
        },
        {
          verse: "3",
          text: "Forbidding to marry, and commanding to abstain from meats, which God hath created to be received with thanksgiving of them which believe and know the truth.",
        },
        {
          verse: "4",
          text: "For every creature of God is good, and nothing to be refused, if it be received with thanksgiving:",
        },
        {
          verse: "5",
          text: "For it is sanctified by the word of God and prayer.",
        },
        {
          verse: "6",
          text: "If thou put the brethren in remembrance of these things, thou shalt be a good minister of Jesus Christ, nourished up in the words of faith and of good doctrine, whereunto thou hast attained.",
        },
        {
          verse: "7",
          text: "But refuse profane and old wives\u2019 fables, and exercise thyself rather unto godliness.",
        },
        {
          verse: "8",
          text: "For bodily exercise profiteth little: but godliness is profitable unto all things, having promise of the life that now is, and of that which is to come.",
        },
        {
          verse: "9",
          text: "This is a faithful saying and worthy of all acceptation.",
        },
        {
          verse: "10",
          text: "For therefore we both labour and suffer reproach, because we trust in the living God, who is the Saviour of all men, specially of those that believe.",
        },
        { verse: "11", text: "These things command and teach." },
        {
          verse: "12",
          text: "Let no man despise thy youth; but be thou an example of the believers, in word, in conversation, in charity, in spirit, in faith, in purity.",
        },
        {
          verse: "13",
          text: "Till I come, give attendance to reading, to exhortation, to doctrine.",
        },
        {
          verse: "14",
          text: "Neglect not the gift that is in thee, which was given thee by prophecy, with the laying on of the hands of the presbytery.",
        },
        {
          verse: "15",
          text: "Meditate upon these things; give thyself wholly to them; that thy profiting may appear to all.",
        },
        {
          verse: "16",
          text: "Take heed unto thyself, and unto the doctrine; continue in them: for in doing this thou shalt both save thyself, and them that hear thee.",
        },
      ],
    },
    {
      chapter: "5",
      verses: [
        {
          verse: "1",
          text: "Rebuke not an elder, but intreat him as a father; and the younger men as brethren;",
        },
        {
          verse: "2",
          text: "The elder women as mothers; the younger as sisters, with all purity.",
        },
        { verse: "3", text: "Honour widows that are widows indeed." },
        {
          verse: "4",
          text: "But if any widow have children or nephews, let them learn first to shew piety at home, and to requite their parents: for that is good and acceptable before God.",
        },
        {
          verse: "5",
          text: "Now she that is a widow indeed, and desolate, trusteth in God, and continueth in supplications and prayers night and day.",
        },
        {
          verse: "6",
          text: "But she that liveth in pleasure is dead while she liveth.",
        },
        {
          verse: "7",
          text: "And these things give in charge, that they may be blameless.",
        },
        {
          verse: "8",
          text: "But if any provide not for his own, and specially for those of his own house, he hath denied the faith, and is worse than an infidel.",
        },
        {
          verse: "9",
          text: "Let not a widow be taken into the number under threescore years old, having been the wife of one man,",
        },
        {
          verse: "10",
          text: "Well reported of for good works; if she have brought up children, if she have lodged strangers, if she have washed the saints\u2019 feet, if she have relieved the afflicted, if she have diligently followed every good work.",
        },
        {
          verse: "11",
          text: "But the younger widows refuse: for when they have begun to wax wanton against Christ, they will marry;",
        },
        {
          verse: "12",
          text: "Having damnation, because they have cast off their first faith.",
        },
        {
          verse: "13",
          text: "And withal they learn to be idle, wandering about from house to house; and not only idle, but tattlers also and busybodies, speaking things which they ought not.",
        },
        {
          verse: "14",
          text: "I will therefore that the younger women marry, bear children, guide the house, give none occasion to the adversary to speak reproachfully.",
        },
        { verse: "15", text: "For some are already turned aside after Satan." },
        {
          verse: "16",
          text: "If any man or woman that believeth have widows, let them relieve them, and let not the church be charged; that it may relieve them that are widows indeed.",
        },
        {
          verse: "17",
          text: "Let the elders that rule well be counted worthy of double honour, especially they who labour in the word and doctrine.",
        },
        {
          verse: "18",
          text: "For the scripture saith, Thou shalt not muzzle the ox that treadeth out the corn. And, The labourer is worthy of his reward.",
        },
        {
          verse: "19",
          text: "Against an elder receive not an accusation, but before two or three witnesses.",
        },
        {
          verse: "20",
          text: "Them that sin rebuke before all, that others also may fear.",
        },
        {
          verse: "21",
          text: "I charge thee before God, and the Lord Jesus Christ, and the elect angels, that thou observe these things without preferring one before another, doing nothing by partiality.",
        },
        {
          verse: "22",
          text: "Lay hands suddenly on no man, neither be partaker of other men\u2019s sins: keep thyself pure.",
        },
        {
          verse: "23",
          text: "Drink no longer water, but use a little wine for thy stomach\u2019s sake and thine often infirmities.",
        },
        {
          verse: "24",
          text: "Some men\u2019s sins are open beforehand, going before to judgment; and some men they follow after.",
        },
        {
          verse: "25",
          text: "Likewise also the good works of some are manifest beforehand; and they that are otherwise cannot be hid.",
        },
      ],
    },
    {
      chapter: "6",
      verses: [
        {
          verse: "1",
          text: "Let as many servants as are under the yoke count their own masters worthy of all honour, that the name of God and his doctrine be not blasphemed.",
        },
        {
          verse: "2",
          text: "And they that have believing masters, let them not despise them, because they are brethren; but rather do them service, because they are faithful and beloved, partakers of the benefit. These things teach and exhort.",
        },
        {
          verse: "3",
          text: "If any man teach otherwise, and consent not to wholesome words, even the words of our Lord Jesus Christ, and to the doctrine which is according to godliness;",
        },
        {
          verse: "4",
          text: "He is proud, knowing nothing, but doting about questions and strifes of words, whereof cometh envy, strife, railings, evil surmisings,",
        },
        {
          verse: "5",
          text: "Perverse disputings of men of corrupt minds, and destitute of the truth, supposing that gain is godliness: from such withdraw thyself.",
        },
        { verse: "6", text: "But godliness with contentment is great gain." },
        {
          verse: "7",
          text: "For we brought nothing into this world, and it is certain we can carry nothing out.",
        },
        {
          verse: "8",
          text: "And having food and raiment let us be therewith content.",
        },
        {
          verse: "9",
          text: "But they that will be rich fall into temptation and a snare, and into many foolish and hurtful lusts, which drown men in destruction and perdition.",
        },
        {
          verse: "10",
          text: "For the love of money is the root of all evil: which while some coveted after, they have erred from the faith, and pierced themselves through with many sorrows.",
        },
        {
          verse: "11",
          text: "But thou, O man of God, flee these things; and follow after righteousness, godliness, faith, love, patience, meekness.",
        },
        {
          verse: "12",
          text: "Fight the good fight of faith, lay hold on eternal life, whereunto thou art also called, and hast professed a good profession before many witnesses.",
        },
        {
          verse: "13",
          text: "I give thee charge in the sight of God, who quickeneth all things, and before Christ Jesus, who before Pontius Pilate witnessed a good confession;",
        },
        {
          verse: "14",
          text: "That thou keep this commandment without spot, unrebukeable, until the appearing of our Lord Jesus Christ:",
        },
        {
          verse: "15",
          text: "Which in his times he shall shew, who is the blessed and only Potentate, the King of kings, and Lord of lords;",
        },
        {
          verse: "16",
          text: "Who only hath immortality, dwelling in the light which no man can approach unto; whom no man hath seen, nor can see: to whom be honour and power everlasting. Amen.",
        },
        {
          verse: "17",
          text: "Charge them that are rich in this world, that they be not highminded, nor trust in uncertain riches, but in the living God, who giveth us richly all things to enjoy;",
        },
        {
          verse: "18",
          text: "That they do good, that they be rich in good works, ready to distribute, willing to communicate;",
        },
        {
          verse: "19",
          text: "Laying up in store for themselves a good foundation against the time to come, that they may lay hold on eternal life.",
        },
        {
          verse: "20",
          text: "O Timothy, keep that which is committed to thy trust, avoiding profane and vain babblings, and oppositions of science falsely so called:",
        },
        {
          verse: "21",
          text: "Which some professing have erred concerning the faith. Grace be with thee. Amen.",
        },
      ],
    },
  ],
};
